module.exports = __webpack_public_path__ + "static/imei_example2_guide-a915c38a5280b1c4b7ea0c96a2a43db3.png";